import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import global from '../../../common/utility/global';


import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {




    const datediff = (endDate) => {

        var date = new Date();
        var yyyy = date.getFullYear();
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var dd = String(date.getDate()).padStart(2, '0');
        var dateResult = (mm + '/' + dd + '/' + yyyy);


        var dia = endDate.split('/')[0];
        var mes = endDate.split('/')[1];
        var anio = endDate.split('/')[2];

        var dateResult1 = (mes + '/' + dia + '/' + anio);


        var date1 = new Date(dateResult1);
        var date2 = new Date(dateResult);

        // To calculate the time difference of two dates
        var Difference_In_Time = date2.getTime() - date1.getTime();

        // To calculate the no. of days between two dates
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

        return Difference_In_Days;

    }

    //alert();

    return (
        <CustomTable
            style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}

            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">


                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingVer}
                                    onClick={() => props.onHistorial(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Historial">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    hidden={true}
                                    onClick={() => props.onView(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Imprimir">
                                <Button
                                    // loading={props.loadingImprimir}
                                    type="info"
                                    icon="printer"
                                    size={"small"}
                                    hidden={true}
                                //onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Fecha Comprobante',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Nro Comprobante',
                    dataIndex: 'serieDocumentoComprobante',
                    key: 'serieDocumentoComprobante',
                    sorter: true
                },

                {
                    title: 'Tipo Comprobante',
                    dataIndex: 'nombreTipoComprobante',
                    key: 'nombreTipoComprobante',
                    sorter: true
                },
                {
                    title: 'Fecha Vencimiento',
                    dataIndex: 'fechaVencemientoStr',
                    key: 'fechaVencemientoStr',
                    sorter: true
                },
                {
                    title: 'Dias Vencidos',
                    dataIndex: 'diasVencido',
                    key: 'diasVencido',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            {(() => {

                                if (row.idCuentasEstado != 3) {
                                    var diasVen = datediff(row.fechaVencemientoStr);
                                    if (diasVen < 0 || diasVen == 0) {
                                        return <Tag color={"brown"}>{0}</Tag>;

                                    }
                                    else {
                                        if (row.idCuentasEstado == 4) {
                                            return <Tag color={"red"}>{0}</Tag>;

                                        }
                                        return <Tag color={"red"}>{Math.abs(diasVen)}</Tag>;

                                    }
                                } else {

                                    if (row.idCuentasEstado == 2) {
                                        return <Tag color={value > 0 || value == 0 ? 'brown' : 'green'}>{value}</Tag>;

                                    }
                                    if (row.idCuentasEstado == 3) {
                                        return <Tag color={'green'}>{value}</Tag>;

                                    }
                                }

                            })()}

                        </div>)
                    }
                },
                {
                    title: 'Vendedor',
                    dataIndex: 'vendedor',
                    key: 'vendedor',
                    sorter: true
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Nro Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'numeroDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Cliente',
                    dataIndex: 'razonSocialCliente',
                    key: 'razonSocialCliente',
                    sorter: true
                },
                {
                    title: 'Moneda Original',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },

                {
                    title: 'Total',
                    dataIndex: 'totalSoles',
                    key: 'totalSoles',
                    align: 'right',
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambio',
                    key: 'tipoCambio',
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },

                {
                    title: 'Cobrado',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Soles',
                            dataIndex: 'canceladoSoles',
                            key: 'canceladoSoles',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        },
                        {
                            title: 'Dólares',
                            dataIndex: 'canceladoDolares',
                            key: 'canceladoDolares',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        }
                    ]
                },
                {
                    title: 'Por Cobrar',
                    dataIndex: 'saldoSoles',
                    key: 'saldoSoles',
                    align: 'right',
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },


                {
                    title: 'Estado',
                    dataIndex: 'idCuentasEstado',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',

                    render: (value, row) => {
                        return (<div className="custom-options" >
                            {(() => {
                                switch (value) {
                                    case 1: //registado
                                        return <Tag color={"red"}>{row.nombreCuentasEstado}</Tag>;
                                    case 2://ANULADA
                                        return <Tag color={"green"}>{row.nombreCuentasEstado}</Tag>;
                                    case 3://APERTURADA
                                        return <Tag color={"green"}>{row.nombreCuentasEstado}</Tag>;
                                    case 4://CERRADO
                                        return <Tag color={"orange"}>{row.nombreCuentasEstado}</Tag>;
                                    case 5://PARCIAL
                                        return <Tag color={"blue"}>{row.nombreCuentasEstado}</Tag>;
                                    default:
                                        return <Tag color={"green"}>{row.nombreCuentasEstado}</Tag>;
                                }
                            })()}

                        </div>)
                    }
                }
            ]}
        />
    );
}